import styled from 'styled-components';
import { customMedia } from 'styles/utils';

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  padding: 2rem 4vw;
`;

export const MainErrorWrapper = styled(MainWrapper)`
  p {
    color: ${props => props.theme.color.wfOrange};
  }
`;

export const LoadingBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 150px;
  height: 4px;
  margin: ${props => props.theme.spacing.large} 0;
  background-color: ${props => props.theme.color.wfGrey200};
`;

export const LoadingMainBar = styled.div`
  width: ${props => (props.percentage ? props.percentage : '0%')};
  height: 4px;
  background-color: ${props => props.theme.color.wfYellow};
`;

export const LoopWrapper = styled.div`
  width: 100%;
  height: 28rem;
  margin: -6rem 0;

  ${customMedia.greaterThan('large')`
    margin: -4rem 0;
  `}
`;
